module.exports = __webpack_public_path__ + "img/Chili Icon - charcoal.eec7f187.svg";